module.exports = __webpack_public_path__ + "img/logo_white.5f1a2adf.svg";